import {IAthlete} from '../10. Battle/types';
import {Weight} from '../10. Battle/Util';

/** Маппинг веса атлета (topo) → ключ v2 из ORDERED_KEYS. */
export function athleteToWeightClassKey(
	athlete: IAthlete,
	weight: Weight | undefined,
	standardKeys: string[],
): string | null {
	if (!weight) {
		return null;
	}
	const isWomen = athlete.Sex !== 1 || weight.Sex !== 1;
	if (isWomen) {
		const womenKey = `Women's ${weight.Name}`;
		if (standardKeys.includes(womenKey)) {
			return womenKey;
		}
	}
	if (standardKeys.includes(weight.Name)) {
		return weight.Name;
	}
	return null;
}
